__turbopack_context__.v({
  "addButton": "b2f1gq_addButton",
  "body": "b2f1gq_body",
  "card": "b2f1gq_card",
  "cardBody": "b2f1gq_cardBody",
  "cardBorder_info": "b2f1gq_cardBorder_info",
  "cardBorder_success": "b2f1gq_cardBorder_success",
  "cardBorder_urgent": "b2f1gq_cardBorder_urgent",
  "cardBorder_warning": "b2f1gq_cardBorder_warning",
  "cardDescription": "b2f1gq_cardDescription",
  "cardFooter": "b2f1gq_cardFooter",
  "cardHeader": "b2f1gq_cardHeader",
  "cardTitle": "b2f1gq_cardTitle",
  "cardTitleRow": "b2f1gq_cardTitleRow",
  "closeButton": "b2f1gq_closeButton",
  "container": "b2f1gq_container",
  "footer": "b2f1gq_footer",
  "grid": "b2f1gq_grid",
  "header": "b2f1gq_header",
  "headerTitle": "b2f1gq_headerTitle",
  "kebabButton": "b2f1gq_kebabButton",
  "kebabContainer": "b2f1gq_kebabContainer",
  "kebabMenu": "b2f1gq_kebabMenu",
  "kebabMenuItem": "b2f1gq_kebabMenuItem",
  "legend": "b2f1gq_legend",
  "legendLabel": "b2f1gq_legendLabel",
  "searchContainer": "b2f1gq_searchContainer",
  "searchIcon": "b2f1gq_searchIcon",
  "searchInput": "b2f1gq_searchInput",
  "toolbar": "b2f1gq_toolbar",
  "toolbarLeft": "b2f1gq_toolbarLeft",
});
